"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("@nicbase/hooks");

var _dualList = _interopRequireWildcard(require("./dual-list"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var compareLabels = function compareLabels(value1, value2) {
  var label1 = value1.label;
  var label2 = value2.label;

  if (label1 === null || label1 === undefined) {
    return 1;
  }

  if (label2 === null || label2 === undefined) {
    return -1;
  }

  return label1.toString().localeCompare(label2.toString());
};

var DualListController = function DualListController(_ref) {
  var selectableItems = _ref.selectableItems,
      selectedItems = _ref.selectedItems,
      onSelect = _ref.onSelect,
      onSelectAll = _ref.onSelectAll,
      onDeselect = _ref.onDeselect,
      onDeselectAll = _ref.onDeselectAll,
      disabled = _ref.disabled,
      filterable = _ref.filterable,
      filterLabel = _ref.filterLabel,
      displayAssignedItemTotals = _ref.displayAssignedItemTotals,
      assignedItemsText = _ref.assignedItemsText,
      notAssignedItemsText = _ref.notAssignedItemsText;

  var _useState = (0, _react.useState)(selectableItems.sort(compareLabels)),
      _useState2 = _slicedToArray(_useState, 2),
      currentSelectableItems = _useState2[0],
      setCurrentSelectableItems = _useState2[1];

  var _useState3 = (0, _react.useState)(selectedItems.sort(compareLabels)),
      _useState4 = _slicedToArray(_useState3, 2),
      currentSelectedItems = _useState4[0],
      setCurrentSelectedItems = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      currentSelectedFilter = _useState6[0],
      setCurrentSelectedFilter = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      currentSelectableFilter = _useState8[0],
      setCurrentSelectableFilter = _useState8[1];

  (0, _hooks.useDidUpdate)(function () {
    setCurrentSelectableItems(selectableItems.sort(compareLabels));
  }, [selectableItems]);
  (0, _hooks.useDidUpdate)(function () {
    setCurrentSelectedItems(selectedItems.sort(compareLabels));
  }, [selectedItems]);

  var select = function select() {
    var itemsToAdd = currentSelectableItems.filter(function (item) {
      return item.selected;
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        selected: false
      });
    });
    var newSelected = currentSelectedItems.slice().concat(itemsToAdd).sort(compareLabels);
    var newSelectable = currentSelectableItems.filter(function (item) {
      return !item.selected;
    }).sort(compareLabels);
    setCurrentSelectedItems(newSelected);
    setCurrentSelectableItems(newSelectable);
    onSelect(newSelected, newSelectable);
  };

  var selectAll = function selectAll() {
    var newSelectedItems = selectedItems.slice();
    var newSelectableItems = [];
    var lowerCaseFilter = currentSelectableFilter.toLowerCase();

    for (var i = 0; i < selectableItems.length; i += 1) {
      var item = _objectSpread(_objectSpread({}, selectableItems[i]), {}, {
        selected: false
      });

      if ((0, _dualList.filterItem)(item, lowerCaseFilter)) {
        newSelectedItems.push(item);
      } else {
        newSelectableItems.push(item);
      }
    }

    newSelectedItems.sort(compareLabels);
    newSelectableItems.sort(compareLabels);
    setCurrentSelectedItems(newSelectedItems);
    setCurrentSelectableItems(newSelectableItems);
    onSelectAll(newSelectedItems, newSelectableItems);
  };

  var deselect = function deselect() {
    var itemsToDeselect = currentSelectedItems.filter(function (item) {
      return item.selected;
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        selected: false
      });
    });
    var newSelected = currentSelectedItems.filter(function (item) {
      return !item.selected;
    }).sort(compareLabels);
    var newSelectable = currentSelectableItems.slice().concat(itemsToDeselect).sort(compareLabels);
    setCurrentSelectedItems(newSelected);
    setCurrentSelectableItems(newSelectable);
    onDeselect(newSelectable, newSelected);
  };

  var deselectAll = function deselectAll() {
    var newSelectedItems = [];
    var newSelectableItems = currentSelectableItems.slice();
    var lowerCaseFilter = currentSelectedFilter.toLowerCase();

    for (var i = 0; i < currentSelectedItems.length; i += 1) {
      var item = _objectSpread(_objectSpread({}, currentSelectedItems[i]), {}, {
        selected: false
      });

      if ((0, _dualList.filterItem)(item, lowerCaseFilter)) {
        newSelectableItems.push(item);
      } else {
        newSelectedItems.push(item);
      }
    }

    newSelectedItems.sort(compareLabels);
    newSelectableItems.sort(compareLabels);
    setCurrentSelectedItems(newSelectedItems);
    setCurrentSelectableItems(newSelectableItems);
    onDeselectAll(newSelectableItems, newSelectedItems);
  };

  var onDoubleClickSelectableItem = function onDoubleClickSelectableItem(doubleClickedItem) {
    var itemsToAdd = _objectSpread(_objectSpread({}, doubleClickedItem), {}, {
      selected: false
    });

    var newSelected = currentSelectedItems.slice().concat(itemsToAdd).sort(compareLabels);
    var newSelectable = currentSelectableItems.filter(function (item) {
      return item.id !== doubleClickedItem.id;
    }).sort(compareLabels);
    setCurrentSelectedItems(newSelected);
    setCurrentSelectableItems(newSelectable);
    onSelect(newSelected, newSelectable);
  };

  var onDoubleClickSelectedItem = function onDoubleClickSelectedItem(doubleClickedItem) {
    var itemsToDeselect = _objectSpread(_objectSpread({}, doubleClickedItem), {}, {
      selected: false
    });

    var newSelected = currentSelectedItems.filter(function (item) {
      return item.id !== doubleClickedItem.id;
    }).sort(compareLabels);
    var newSelectable = currentSelectableItems.slice().concat(itemsToDeselect).sort(compareLabels);
    setCurrentSelectedItems(newSelected);
    setCurrentSelectableItems(newSelectable);
    onDeselect(newSelectable, newSelected);
  };

  var filterSelectable = function filterSelectable(filter) {
    setCurrentSelectableFilter(filter);
  };

  var filterSelected = function filterSelected(filter) {
    setCurrentSelectedFilter(filter);
  };

  var toggleSelectableItemChecked = function toggleSelectableItemChecked(checkedItem) {
    var newSelectable = currentSelectableItems.map(function (item) {
      var selected = item.selected;

      if (item.id === checkedItem.id) {
        selected = !selected;
      }

      return _objectSpread(_objectSpread({}, item), {}, {
        selected: selected
      });
    });
    setCurrentSelectableItems(newSelectable);
  };

  var toggleSelectedItemChecked = function toggleSelectedItemChecked(checkedItem) {
    var newSelected = currentSelectedItems.map(function (item) {
      var selected = item.selected;

      if (item.id === checkedItem.id) {
        selected = !selected;
      }

      return _objectSpread(_objectSpread({}, item), {}, {
        selected: selected
      });
    });
    setCurrentSelectedItems(newSelected);
  };

  return /*#__PURE__*/_react["default"].createElement(_dualList["default"], {
    selectableItems: currentSelectableItems,
    selectedItems: currentSelectedItems,
    selectableFilter: currentSelectableFilter,
    selectedFilter: currentSelectedFilter,
    onToggleSelectedItem: toggleSelectedItemChecked,
    onToggleSelectableItem: toggleSelectableItemChecked,
    onDoubleClickSelectableItem: onDoubleClickSelectableItem,
    onDoubleClickSelectedItem: onDoubleClickSelectedItem,
    onChangeSelectableFilter: filterSelectable,
    onChangeSelectedFilter: filterSelected,
    onSelect: select,
    onSelectAll: selectAll,
    onDeselect: deselect,
    onDeselectAll: deselectAll,
    filterable: filterable,
    filterLabel: filterLabel,
    disabled: disabled,
    displayAssignedItemTotals: displayAssignedItemTotals,
    assignedItemsText: assignedItemsText,
    notAssignedItemsText: notAssignedItemsText
  });
};

var noop = function noop() {};

DualListController.defaultProps = {
  selectableItems: [],
  selectedItems: [],
  onSelect: noop,
  onSelectAll: noop,
  onDeselect: noop,
  onDeselectAll: noop,
  disabled: false,
  filterable: true,
  filterLabel: _dualList["default"].defaultProps.filterLabel,
  displayAssignedItemTotals: true,
  assignedItemsText: '',
  notAssignedItemsText: ''
};
var _default = DualListController;
exports["default"] = _default;